var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCwMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.078,
    height: 29.173,
    viewBox: "0 0 29.078 29.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10764",
    "data-name": "Group 10764",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10763",
    "data-name": "Group 10763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19569",
    "data-name": "Path 19569",
    d: "M164.539,60a13.537,13.537,0,0,0-7.287,24.946,13.818,13.818,0,0,0,13.465.735,1.934,1.934,0,0,0-1.617-3.514,10.021,10.021,0,0,1-9.761-.478,9.669,9.669,0,1,1,14.871-8.15,1.934,1.934,0,0,1-3.868.029c0-.01,0-.02,0-.029a5.811,5.811,0,1,0-1.934,4.32,5.8,5.8,0,0,0,9.671-4.32A13.554,13.554,0,0,0,164.539,60Zm1.907,13.849a1.93,1.93,0,1,1,.014-.531A1.936,1.936,0,0,0,166.446,73.849Z",
    transform: "translate(-151 -60)",
    fill: "#fff",
    stroke: "#0087c3",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCwMail);
export default __webpack_public_path__ + "static/media/icon-cw-mail.240a0bf3e9506af8e15df3591a3b014d.svg";
export { ForwardRef as ReactComponent };